/**
 * A single ability-bar slot.
 *
 * Props:
 *   cdProg    — cooldown progress 0→1 (1 = ready)
 *   glyph     — emoji icon
 *   keyLabel  — keyboard hint label (Q/E/W/R)
 *   isReady   — explicit ready override; defaults to cdProg >= 1
 *   isActive  — adds --active modifier (e.g. while dashing)
 *   className — extra CSS classes to append (e.g. ability-icon--potion)
 *   onClick   — click handler
 *   children  — optional extra content (e.g. potion count badge)
 */
export function AbilitySlot({ cdProg, glyph, keyLabel, isReady, isActive, className, onClick, children }) {
  const ready = isReady ?? (cdProg >= 1);

  return (
    <div
      data-mobile-btn="true"
      className={`ability-icon${ready ? ' ability-icon--ready' : ''}${isActive ? ' ability-icon--active' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
    >
      <div className="ability-icon-cd" style={{ height: `${(1 - cdProg) * 100}%` }} />
      <span className="ability-icon-glyph">{glyph}</span>
      <span className="ability-key">{keyLabel}</span>
      {children}
    </div>
  );
}
